import { createSlice } from "@reduxjs/toolkit";
import { topicsGet } from "reduxStore/actions/topics";

const initialState ={
    userLoading: false,  
    topic: [],
    error: null
}

const topicsSlice = createSlice({
    name:'topic',
    initialState, 
    reducers:{}
,
    extraReducers: builder => {
        builder
        .addCase(topicsGet.fulfilled, (state, action) => {
            state.userLoading = false;
            state.topic = action.payload.data;
        })
        .addCase(topicsGet.pending, (state) => {
            state.userLoading = true; 
        })
        .addCase(topicsGet.rejected, (state, action) => {
            state.userLoading = false;  
            state.error = action.payload; 
        });
      
    },
});
export default topicsSlice.reducer